module.exports = __webpack_public_path__ + "img/desktop-2.e7aaea72.png";